import styles from './CardBrandIcon.module.css'
import AmexIcon from './amex.svg?react'
import DinersClubIcon from './diners-club.svg?react'
import DiscoverIcon from './discover.svg?react'
import HumoIcon from './humo.svg?react'
import JcbIcon from './jcb.svg?react'
import MaestroIcon from './maestro.svg?react'
import MastercardIcon from './mastercard.svg?react'
import MirIcon from './mir.svg?react'
import UnionPayIcon from './unionpay.svg?react'
import UzcardIcon from './uzcard.svg?react'
import VisaIcon from './visa.svg?react'

/**
 * Keyed by `card-validator`'s card type, lower-cased: the built-in types are
 * already lower-case, the local ones we register in `validate.js` (HUMO,
 * UZCARD) are not. Brands we have no artwork for simply render nothing — the
 * field stays as it is today.
 */
const icons = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  maestro: MaestroIcon,
  mir: MirIcon,
  humo: HumoIcon,
  uzcard: UzcardIcon,
  'american-express': AmexIcon,
  unionpay: UnionPayIcon,
  jcb: JcbIcon,
  discover: DiscoverIcon,
  'diners-club': DinersClubIcon,
}

export function CardBrandIcon({brand}) {
  const Icon = icons[brand?.toLowerCase()]

  if (!Icon) {
    return null
  }

  return (
    <span className={styles.icon} aria-hidden="true">
      <Icon/>
    </span>
  )
}
